<template>
  <div class="layout-move-group-dialog">
    <div class="kye-dialog-body">
      <!--      <el-tooltip class="item" effect="dark" :content="moveName" placement="top">-->
      <p class="title">被移动模块名称：<span>{{ moveName }}</span></p>
      <!--      </el-tooltip>-->
      <div class="list-menu-list">
        <div class="list-item"
             :class="{'list-item-active': activeGroup && (activeGroup.id === item.id)}"
             v-for="item in dialogData.groupList"
             :key="item.id"
             @click="handleGroupClick(item)">
          <div class="list-item-content">
            <div class="list-item-prefix"></div>
            {{ item.groupName }}
          </div>
        </div>
      </div>
    </div>
    <div class="el-dialog__footer">
      <kye-button type="primary" @click="submit">保存</kye-button>
      <kye-button @click="cancel">取消</kye-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialogData: Object,
  },
  data() {
    return {
      activeGroup: null,
    }
  },
  computed: {
    // 被移动的文件名称
    moveName() {
      return this.dialogData.tag ? this.dialogData.tag.map(item => item.title).join(', ') : ''
    },
  },
  methods: {
    async submit() {
      try {
        const url = 'system.homeIndex.batchMove'
        const params = this.dialogData.tag.map(item => {
          item.moduleGroupId = this.activeGroup.id
          return item
        })
        await this.$http(url, params)
        this.$message.success('保存成功')
        this.$emit('update')
        this.$emit('close')
      } catch (error) {
        console.error(error)
      }
    },
    cancel() {
      this.$emit('close')
    },
    handleGroupClick(item) {
      this.activeGroup = item
    },
  },
}
</script>

<style lang="scss" scoped>
.layout-move-group-dialog {
  color: rgba(69, 60, 90, 1);
  font-size: 14px;

  .title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 20px;
    > span {
      color: #000;
    }
  }
  .list-menu-list {
    padding: 8px 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
    .list-item {
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      padding: 0 8px;
      border-radius: 8px;
      .list-item-content {
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: flex;
        align-items: center;

        .list-item-prefix {
          display: block;
          width: 12px;
          height: 12px;
          margin-right: 4px;
          background: url("../../images/file.svg") no-repeat center / 12px;
        }
      }
      &:hover {
        background: rgba(121, 83, 246, 0.1);
        color: rgba(121, 83, 246, 1);
        .list-item-prefix {
          background: url("../../images/file-active.svg") no-repeat center / 12px;
        }
      }
      &.list-item-active {
        background: rgba(121, 83, 246, 0.1);
        color: rgba(121, 83, 246, 1);
        .list-item-prefix {
          background: url("../../images/file-active.svg") no-repeat center / 12px;
        }
      }
    }
  }
  .el-dialog__footer{
    display: flex;
    justify-content: flex-end;
    .el-button{
      border-radius: 224px;
      height: 34px;
      display: flex;
      gap: 10px;
      padding: 0 20px;
      color: rgba(69, 60, 90, 1);
      font-size: 13px!important;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(224, 223, 239, 1);
      background-color: rgba(249, 249, 254, 1);
      &.el-button--primary{
        color: #fff;
        background-color: rgba(109, 46, 248, 1);
        font-weight: normal;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/move-group-dialog.vue